// Type guard for Brand
export function isBrand(item: any): item is Brand {
  return (item as Brand).tagLine !== undefined;
}

// Type guard for Product
export function isProduct(item: any): item is Product {
  return (item as Product).categoryId !== undefined;
}
